import { Text } from '@mantine/core'

interface DriverNameDisplayProps {
  driverName: string | null
  isMobile: boolean
}

export function DriverNameDisplay({ driverName, isMobile }: DriverNameDisplayProps) {
  const name = driverName || 'N/A'
  const parts = name.split(' ')

  // Vertical display with first name + last name initial
  let verticalText = name
  if (parts.length === 1) {
    // Single name - truncate if too long
    verticalText = parts[0].length > 8 ? parts[0].substring(0, 6) + '...' : parts[0]
  } else if (parts.length >= 2) {
    // Multiple names - show first name + last name initial
    const firstName = parts[0]
    const lastNameInitial = parts[parts.length - 1]?.charAt(0) || ''
    verticalText = `${firstName} ${lastNameInitial}.`
  }

  return (
    <Text
      size="sm"
      fw={600}
      c={driverName ? 'dark' : 'gray'}
      style={{
        fontSize: isMobile ? '10px' : '12px',
        lineHeight: 1.1,
        writingMode: 'vertical-rl',
        transform: 'rotate(180deg)',
        transformOrigin: 'center',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        maxHeight: '100%',
      }}
    >
      {verticalText}
    </Text>
  )
}
